import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom';

// Layout
import Navbar from './components/navbar/navbar';
import { DarkModeProvider } from './components/darkmode/DarkModeContext';
import { AuthProvider } from './pages/auth/AuthContext';
import { ChatProvider } from './components/chatcontext/ChatContext';
import AIAssistantFloat from './components/home/chatbot/FloatingChatAssistant';
import CustomerChat from './pages/chat/CustomerChat';

// Auth
import LoginPage from './pages/auth/login';
import RegisterPage from './pages/auth/register';
import ProtectedRoute from './pages/auth/ProtectedRoute';
import VerifyEmailPage from './pages/auth/verify_email';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';

// Main Pages
import Index from './pages/index';
import InternetPackagesPage from './pages/produk';
import TVIPTVPage from './pages/produk_TV';
import CCTVPage from './pages/CCTV';
import AboutPage from './pages/tentang';
import ContactPage from './pages/kontak';
import GalleryPage from './pages/Gallery/gallery';
import ProfilePage from './pages/ProfilePage';

// Internet Products
import InternetBroadcast from './pages/internet/InternetBroadcast';
import InternetDedicated from './pages/internet/internetdedicated';
import StarlinkPage from './pages/internet/internetStarlink';
import IPPhoneWebsite from './pages/internet/IP-PhonePBX';
import MetroEPage from './pages/internet/metro-e';

// Layanan IT
import InternetRumahPage from './pages/layanan/internet_rumah';
import SpeedTestPage from './pages/layanan/speedtest';
import GamingPage from './pages/layanan/gaming';
import SecureFirewallPage from './pages/layanan/secure_firewall';
import TowerTrianglePage from './pages/layanan/tower_triggle';
import WalkieTalkiePage from './pages/layanan/perangkat_walkie';
import FiberOpticLanPage from './pages/layanan/fiber_optic';
import NetworkDevicePage from './pages/layanan/network_device';
import ComputerEquipmentPage from './pages/layanan/ComputerEquipment';
import ITSupportPage from './pages/layanan/it_support';
import CustomSoftwarePage from './pages/layanan/custum_sofware';
import VPNPage from './pages/layanan/VPN';
import IPASNPage from './pages/layanan/IPASN';
import IPSpeakerPage from './pages/layanan/IP_Speaker';
import TrafficManagementPage from './pages/layanan/traffic_management';

// New Service Pages
import DataCenterPage from './pages/layanan/DataCenter';
import CloudServicesPage from './pages/layanan/CloudServices';
import ErpCrmPage from './pages/layanan/ErpCrm';
import SimrsHrisPage from './pages/layanan/SimrsHris';
import NetworkMonitoringPage from './pages/layanan/NetworkMonitoring';
import MicrosoftLicensingPage from './pages/layanan/MicrosoftLicensing';

// Legal Pages
import KebijakanPrivasi from './pages/legal/KebijakanPrivasi';
import KetentuanLayanan from './pages/legal/KetentuanLayanan';
import AlurTransaksi from './pages/legal/AlurTransaksi';
import FAQ from './pages/legal/FAQ';

// Customer Pages
import CoverageCheckPage from './pages/form_pelangggan';
import CustomerServicePage from './pages/layanan/custumer_service';
import CustomerServicePage2 from './pages/layanan/custumer_service_bot';
import Dashboard from './pages/Dashboard/Dashboard';
import MyPackages from './pages/PaketSaya/paket';
import OrderHistory from './pages/riwayat-pesanan/riwayat-pesanan';
import BillingPage from './pages/tagihan/billingg';
import PaymentPage from './pages/Pembayaran/pembayaran';

// News
import NewsApp from './components/berita/NewsApp';
import NewsDetail from './components/berita/detail_berita';
import NewsHomepage from './pages/berita/index';

// Admin
import AdminDashboard from './pages/admin/dashboard';
import AdminOrders from './pages/admin/order';
import AdminPackages from './pages/admin/adminpackage';
import AdminBillingPage from './pages/admin/adminbilling';
import AdminCustomer from './pages/admin/custumer';
import AdminNewsPage from './pages/admin/adminnews';
import AdminCoverageAreaPage from './pages/admin/admincoveragearea';
import AdminChat from './pages/chat/AdminChat';

// ScrollToTop component
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const HIDE_AI_PATHS = ['/chatbot', '/chat-support', '/customer-service', '/adminchat', '/dashboard-admin', '/admin-order', '/admin-package', '/admin-customer', '/admin-billing', '/admin-news', '/admin-coverage'];
const HIDE_NAVBAR_PATHS = ['/login', '/register', '/adminchat', '/dashboard-admin', '/admin-order', '/admin-package', '/admin-customer', '/admin-billing', '/admin-news', '/admin-coverage'];

const AppContent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showNavbar = !HIDE_NAVBAR_PATHS.includes(location.pathname);
  const showAI = !HIDE_AI_PATHS.includes(location.pathname);

  return (
    <>
      <ScrollToTop />
      {showNavbar && <Navbar />}

      <div key={location.pathname} className="animate-fade-in">
        <Routes>
          {/* Public Pages */}
          <Route path="/" element={<Index />} />
          <Route path="/produk" element={<InternetPackagesPage />} />
          <Route path="/tv-iptv" element={<TVIPTVPage />} />
          <Route path="/cctv" element={<CCTVPage />} />
          <Route path="/tentang" element={<AboutPage />} />
          <Route path="/kontak/*" element={<ContactPage />} />
          <Route path="/gallery" element={<GalleryPage />} />

          {/* Auth */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

          {/* Internet Products */}
          <Route path="/internet/broadband" element={<InternetBroadcast />} />
          <Route path="/internet/dedicated" element={<InternetDedicated />} />
          <Route path="/internet/metro-e" element={<MetroEPage />} />
          <Route path="/produk-lainnya/starlink" element={<StarlinkPage />} />
          <Route path="/produk-lainnya/vpn" element={<VPNPage />} />
          <Route path="/produk-lainnya/traffic-management" element={<TrafficManagementPage />} />
          <Route path="/produk-lainnya/secure-firewall" element={<SecureFirewallPage />} />
          <Route path="/produk-lainnya/ip-asn" element={<IPASNPage />} />

          {/* Layanan IT */}
          <Route path="/internetrumah" element={<InternetRumahPage />} />
          <Route path="/speedtest" element={<SpeedTestPage />} />
          <Route path="/gaming" element={<GamingPage />} />
          <Route path="/layanan-it/ip-phone" element={<IPPhoneWebsite />} />
          <Route path="/layanan-it/ip-speaker" element={<IPSpeakerPage />} />
          <Route path="/layanan-it/tower-triangle" element={<TowerTrianglePage />} />
          <Route path="/layanan-it/walkie_talkie" element={<WalkieTalkiePage />} />
          <Route path="/layanan-it/fiber_optic" element={<FiberOpticLanPage />} />
          <Route path="/layanan-it/network_device" element={<NetworkDevicePage />} />
          <Route path="/layanan-it/computer_equipment" element={<ComputerEquipmentPage />} />
          <Route path="/layanan-it/it_support" element={<ITSupportPage />} />
          <Route path="/layanan-it/custom_sofware" element={<CustomSoftwarePage />} />

          {/* New Service Pages */}
          <Route path="/layanan/data-center" element={<DataCenterPage />} />
          <Route path="/layanan/cloud-services" element={<CloudServicesPage />} />
          <Route path="/layanan/erp-crm" element={<ErpCrmPage />} />
          <Route path="/layanan/simrs-hris" element={<SimrsHrisPage />} />
          <Route path="/layanan/network-monitoring" element={<NetworkMonitoringPage />} />
          <Route path="/layanan/microsoft-licensing" element={<MicrosoftLicensingPage />} />

          {/* Legal Pages */}
          <Route path="/kebijakan-privasi" element={<KebijakanPrivasi />} />
          <Route path="/ketentuan-layanan" element={<KetentuanLayanan />} />
          <Route path="/alur-transaksi" element={<AlurTransaksi />} />
          <Route path="/faq" element={<FAQ />} />

          {/* Customer Service */}
          <Route path="/chatbot" element={<CustomerServicePage />} />
          <Route path="/customer-service" element={<CustomerServicePage2 />} />
          <Route path="/chat-support" element={<CustomerServicePage2 />} />
          <Route path="/detail-langganan" element={<CoverageCheckPage />} />
          <Route path="/coverage-check" element={<CoverageCheckPage />} />

          {/* Protected - User */}
          <Route path="/profile" element={<ProtectedRoute requireAuth={true}><ProfilePage /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute requireAuth={true}><Dashboard /></ProtectedRoute>} />
          <Route path="/my-packages" element={<ProtectedRoute requireAuth={true}><MyPackages /></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute requireAuth={true}><OrderHistory /></ProtectedRoute>} />
          <Route path="/billing" element={<ProtectedRoute requireAuth={true}><BillingPage /></ProtectedRoute>} />
          <Route path="/pembayaran" element={<ProtectedRoute requireAuth={true}><PaymentPage /></ProtectedRoute>} />

          {/* News */}
          <Route path="/news" element={<NewsHomepage />} />
          <Route path="/news/*" element={<NewsApp />} />
          <Route path="/detail_berita" element={<NewsDetail />} />

          {/* Admin */}
          <Route path="/dashboard-admin" element={<AdminDashboard />} />
          <Route path="/admin-order" element={<AdminOrders />} />
          <Route path="/admin-package" element={<AdminPackages />} />
          <Route path="/admin-customer" element={<AdminCustomer />} />
          <Route path="/admin-billing" element={<AdminBillingPage />} />
          <Route path="/admin-news" element={<AdminNewsPage />} />
          <Route path="/admin-coverage" element={<AdminCoverageAreaPage />} />
          <Route path="/adminchat" element={<AdminChat />} />
        </Routes>
      </div>

      {location.pathname !== '/adminchat' && <CustomerChat />}
      {showAI && <AIAssistantFloat navigate={navigate} />}
    </>
  );
};

const App = () => (
  <DarkModeProvider>
    <AuthProvider>
      <ChatProvider>
        <Router>
          <AppContent />
        </Router>
      </ChatProvider>
    </AuthProvider>
  </DarkModeProvider>
);

export default App;
